import http from '@/communication/AuthConnection'

export default async ({ commit }, { eventId }) => {
  try {
    const request = await http.get(`/v1/bid-mirror/${eventId}`)
    const bidMirror = request.data.bidMirror || []

    return { bidMirror }
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/bid-mirror/GetBidMirrorByEvent.js